import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { CategoryOccupancy, useRepositoryQuery } from '@mews-commander/data-access';
import { useTimezone } from '@mews/framework';
import { WithServiceId } from '@mews-commander/types';
import { useServiceInfo } from '@mews-commander/legacy-entities/src/utils/useServiceInfo';
import { getMinimalDateTimeInterval } from '../components/NewReservationPanel/utils/dateTime';
import { getRateGroupsFromPricing } from '../reducers/rateGroups';

interface Params extends WithServiceId {
    startUtc: string;
    endUtc: string;
    categoryOccupancies: CategoryOccupancy[];
}

export const useRatePricingQuery = ({ serviceId, startUtc, endUtc, categoryOccupancies }: Params) => {
    const { timeUnit } = useServiceInfo(serviceId);
    const timezone = useTimezone();

    const sumOfPeople = pipe(
        categoryOccupancies,
        array.flatMap(({ occupancyData }) => occupancyData?.map(({ personCount }) => personCount ?? 0) ?? []),
        array.reduce(0, (acc, count) => acc + count)
    );

    return useRepositoryQuery(
        'services',
        'getRatePricing',
        {
            serviceId,
            categoryOccupancies,
            ...getMinimalDateTimeInterval({ startUtc, endUtc }, timeUnit, timezone),
        },
        {
            enabled: !!endUtc && !!startUtc && startUtc < endUtc && sumOfPeople > 0,
            select: (resp) => ({
                ...resp,
                rateGroups: getRateGroupsFromPricing(resp.offer).rateGroups,
            }),
        }
    );
};
